import {
    FEATURED_PRODUCTS_FETCH_REQUESTED,
    FEATURED_PRODUCTS_FETCH_SUCCESS,
    FEATURED_PRODUCTS_FETCH_FAILED,
    STORE_CATALOG_FETCH_REQUESTED,
    STORE_CATALOG_FETCH_SUCCESS,
    STORE_CATALOG_FETCH_FAILED,
    STORE_PRODUCT_FETCH_REQUESTED,
    STORE_PRODUCT_FETCH_SUCCESS,
    STORE_PRODUCT_FETCH_FAILED,
} from '../actions/types';

import _ from 'lodash';

const INITIAL_STATE = {
    featured: {
        items: [],
        hasMore: false,
        nextOffset: null,
        isFetching: false,
        isFetchingMore: false,
        failed: false,
        loaded: false,
    },
    // { [storeId]: { items, hasMore, nextOffset, isFetching, isFetchingMore, failed, loaded } }
    byStore: {},
    // { [productId]: { product, isFetching, notFound, failed } }
    products: {},
};

const EMPTY_STORE_CATALOG = {
    items: [],
    hasMore: false,
    nextOffset: null,
    isFetching: false,
    isFetchingMore: false,
    failed: false,
    loaded: false,
};

const updateStore = (state, storeId, changes) => ({
    ...state,
    byStore: {
        ...state.byStore,
        [storeId]: {
            ...EMPTY_STORE_CATALOG,
            ...state.byStore[storeId],
            ...changes,
        },
    },
});

const updateProduct = (state, productId, changes) => ({
    ...state,
    products: {
        ...state.products,
        [productId]: { ...state.products[productId], ...changes },
    },
});

const catalogReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FEATURED_PRODUCTS_FETCH_REQUESTED:
            return {
                ...state,
                featured: {
                    ...state.featured,
                    ...(action.payload && action.payload.offset > 0
                        ? { isFetchingMore: true }
                        : { isFetching: true, failed: false }),
                },
            };
        case FEATURED_PRODUCTS_FETCH_SUCCESS: {
            const { offset, items = [], hasMore, nextOffset } = action.payload;
            const previous = offset > 0 ? state.featured.items : [];
            return {
                ...state,
                featured: {
                    items: _.uniqBy([...previous, ...items], 'productId'),
                    hasMore: !!hasMore,
                    nextOffset: nextOffset === undefined ? null : nextOffset,
                    isFetching: false,
                    isFetchingMore: false,
                    failed: false,
                    loaded: true,
                },
            };
        }
        case FEATURED_PRODUCTS_FETCH_FAILED:
            // si falla una página siguiente conservamos lo ya cargado
            return {
                ...state,
                featured:
                    action.payload && action.payload.offset > 0
                        ? {
                              ...state.featured,
                              isFetchingMore: false,
                              hasMore: false,
                          }
                        : {
                              ...state.featured,
                              isFetching: false,
                              failed: true,
                              loaded: true,
                          },
            };

        case STORE_CATALOG_FETCH_REQUESTED: {
            const { storeId, offset } = action.payload;
            return updateStore(
                state,
                storeId,
                offset > 0
                    ? { isFetchingMore: true }
                    : { isFetching: true, failed: false }
            );
        }
        case STORE_CATALOG_FETCH_SUCCESS: {
            const {
                storeId,
                offset,
                items = [],
                hasMore,
                nextOffset,
            } = action.payload;
            const previous =
                offset > 0 && state.byStore[storeId]
                    ? state.byStore[storeId].items
                    : [];
            return updateStore(state, storeId, {
                items: _.uniqBy([...previous, ...items], 'productId'),
                hasMore: !!hasMore,
                nextOffset: nextOffset === undefined ? null : nextOffset,
                isFetching: false,
                isFetchingMore: false,
                failed: false,
                loaded: true,
            });
        }
        case STORE_CATALOG_FETCH_FAILED: {
            const { storeId, offset } = action.payload;
            // si falla "Ver más" conservamos lo ya cargado
            return updateStore(
                state,
                storeId,
                offset > 0
                    ? { isFetchingMore: false }
                    : { isFetching: false, failed: true, loaded: true }
            );
        }

        case STORE_PRODUCT_FETCH_REQUESTED:
            return updateProduct(state, action.payload.productId, {
                isFetching: true,
                notFound: false,
                failed: false,
            });
        case STORE_PRODUCT_FETCH_SUCCESS:
            return updateProduct(state, action.payload.productId, {
                product: action.payload.product,
                isFetching: false,
                notFound: false,
                failed: false,
            });
        case STORE_PRODUCT_FETCH_FAILED:
            return updateProduct(state, action.payload.productId, {
                // un 404 invalida lo que hubiera cacheado
                product: action.payload.notFound
                    ? null
                    : (state.products[action.payload.productId] || {}).product,
                isFetching: false,
                notFound: action.payload.notFound,
                failed: !action.payload.notFound,
            });
        default:
            return state;
    }
};

export default catalogReducer;
